import api from "@/lib/api";

/** Construye los query params de periodo para los endpoints de /reports. */
export function periodParams({ period, start, end }) {
  const params = { period };
  if (period === "custom") {
    params.start = start;
    params.end = end;
  }
  return params;
}

/** Descarga un reporte (Excel o CSV) generado por GET /reports/export,
 * respetando la autenticacion por cookies del cliente axios compartido. */
export async function downloadReportExport(reportKey, format, period) {
  const response = await api.get("/reports/export", {
    params: { report: reportKey, format, ...periodParams(period) },
    responseType: "blob",
  });
  const disposition = response.headers["content-disposition"] || "";
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match ? match[1] : `reporte.${format === "csv" ? "csv" : "xlsx"}`;
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
